<template>
	<div class="index">
		<nav class="navbar is-fixed-top">
			<div class="container">
				<div class="navbar-brand">
					<div class="navbar-item">
						<img src="/icon-logo.png" width="174" height="40" :src="require('@/assets/img/icon-logo.png')" alt="">
					</div>
					<div class="navbar-burger" :class="is_active?'is-active':''" @click="is_active=!is_active">
						<span aria-hidden="true"></span>
						<span aria-hidden="true"></span>
						<span aria-hidden="true"></span>
					</div>
				</div>
				<div class="navbar-menu" :class="is_active?'is-active':''">
					<div class="navbar-start">
						<router-link :to="{path:'/'}" class="navbar-item" :class="path=='/'?'is-current':''">首页</router-link>
						<router-link :to="{path:'/course_list'}" class="navbar-item" :class="path=='/course_list'?'is-current':''">全部课程</router-link>
						<a href="javascript:;" class="navbar-item" :class="path=='/user_detail'?'is-current':''" @click="url">我的积分</a>
					</div>
					<div class="navbar-end">
						<div class="navbar-item">
							<div class="control">
								<div style="align-items: center" class="is-flex columns is-paddingless is-marginless">
									<div style="align-items: center" class="is-flex is-full-mobile column is-paddingless">
										<span class="icon is-small">
											<svg class="svg-inline--fa fa-search fa-w-16" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>
										</span>
										<div style="flex-grow: 1; margin-right: 15px;">
											<input v-model="search_input" style="margin-left: 10px;" @keyup.enter="enter" class="input is-small is-full-mobile" type="text" placeholder="搜索课程">
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="navbar-item has-dropdown is-hoverable" v-if="user.id">
							<div class="navbar-link">{{user.username}}</div>
							<div class="navbar-dropdown">
								<router-link :to="{path:'/user_detail'}" class="navbar-item">用户中心</router-link>
								<hr class="navbar-divider">
								<div class="navbar-item" @click="art_logout()">登出</div>
							</div>
						</div>
						<div class="navbar-item" v-else>
							<div class="buttons">
								<div class="button is-login modal-button" @click="click_login()">
									<span>登录</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</nav>
		<div class="modal modal--user-login is-active" v-if="is_login">
			<div class="modal-background"></div>
			<div class="modal-content">
				<div class="container login-modal">
					<div class="columns">
						<div class="column is-2 is-0-mobile"></div>
						<div class="column is-12-mobile">
							<h2 class="is-centered has-text-centered is-size-3 is-size-4-touch" style="margin-top: 20px;margin-bottom: 20px;">登录</h2>
							<div class="new_user">
								<div class="field">
									<label class="label" for="user_email">请输入邮箱</label>
									<p class="control has-icons-left has-icons-right">
										<input v-model="form.email" autofocus="autofocus" autocomplete="email" class="input" type="email">
										<span class="icon is-small is-left">
											<svg class="svg-inline--fa fa-envelope fa-w-16" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="envelope" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"></path></svg>
										</span>
									</p>
								</div>
								<div class="field">
									<label class="label" for="user_password">请输入密码</label>
									<p class="control has-icons-left has-icons-right">
										<input v-model="form.password" autocomplete="current-password" class="input" type="password">
										<span class="icon is-small is-left">
											<svg class="svg-inline--fa fa-lock fa-w-14" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="lock" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"></path></svg>
										</span>
									</p>
								</div>
								<div class="field">
									<p class="control">
										<input type="checkbox" value="1" v-model="user_remember_me" id="user_remember_me">
										<label for="user_remember_me">记住密码</label>
									</p>
								</div>
								<div class="field">
									<p class="control">
										<span class="button is-primary" @click="art_login">登录</span>
									</p>
								</div>
							</div>
						</div>
						<div class="column is-2 is-0-mobile"></div>
					</div>
				</div>
			</div>
			<button class="modal-close is-large" @click="click_close()"></button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'header_html',
	data() {
		return {
			is_active: false,
			is_login: false,
			index_on: 0,
			wap_nav: false,
			path: this.$route.path,
			user:{},
			user_remember_me:false,
			form:{
				email:'',
				password:'',
			},
			search_input:'',
		}
	},
	// 初始事件
	mounted: function() {
		if(this.$route.query&&this.$route.query.search_input){
			this.search_input = this.$route.query.search_input
		}
		var token = sessionStorage.getItem('token') || '';
		if(token){
			this.init();
		}
	},
	methods: {
		init(){
			var url = "front/art_account";
			this.$get(url, {}).then((res) => {
				this.user=res.data;
			});
		},
		art_login(){
			var url = "art_login";
			if(!this.form.email){
				this.$message.error('请输入邮箱');
				return
			}
			if(!this.form.email){
				this.$message.error('请输入密码');
				return
			}
			this.$post(url, this.form).then((res) => {
				sessionStorage.setItem('token',res.data.access_token);
				if(this.user_remember_me){
					var account = JSON.stringify(this.form);
					localStorage.setItem('account',account);
				}else{
					localStorage.removeItem('account');
				}
				this.$message.success('登录成功');
				this.is_login=false;
				this.init();
				this.$emit('callback');
				this.form={
					email:'',
					password:'',
				}
				this.user_remember_me=false;
			}).catch((res)=>{
				this.$message.error(res);
			})
		},
		click_login(){
			var account = localStorage.getItem('account') || '';
			if(account){
				this.form=JSON.parse(account);
				this.user_remember_me=true;
			}
			this.is_login = true;
		},
		art_logout(){
			this.$confirm('确认退出吗?', '提示').then(() => {
				this.$get('art_logout',{}).then((res) => {
					this.user={};
					sessionStorage.removeItem('token');
					if(this.path=='/user_detail'||this.path=='/course_detail'){
						this.$router.push({path:'/'});
					}
				})
			})
		},
		url(){
			var token = sessionStorage.getItem('token') || '';
			if(token){
				this.$router.push({path:'/user_detail'});
			}else{
				this.click_login();
			}
		},
		enter(){
			if(this.path!='/search'){
				this.$router.push({
					path:'/search',
					query:{
						search_input:this.search_input
					}
				});
			}else{
				this.$emit('callback_search',this.search_input);
			}
		},
		click_close(){
			this.is_login=false;
			console.log(this.path)
			if(this.path=='/user_detail'||this.path=='/course_detail'){
				this.$router.push({path:'/'});
			}
		}
	}
	
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header_html.vue